import Registration from '@/apps/registration/seeker/Registration.vue';
import CareTypeForm from '@/apps/registration/seeker/CareTypeForm.vue';
import AddYourEmployer from '@/apps/registration/seeker/AddEmployer/AddYourEmployer.vue';
import RequestUpgrade from '@/apps/registration/seeker/AddEmployer/RequestUpgrade.vue';
import UpgradeRequestSent from '@/apps/registration/seeker/AddEmployer/UpgradeRequestSent.vue';
import Location from '@/apps/registration/seeker/Location.vue';
import { requireSeeker } from '../guards/authGuards';
import setSimpleHeaderGuard from '../guards/simpleHeaderGuard';
import combineGuards from '../guards/helpers';

/**
 * Registration flow routes for new seekers (parents/families).
 *
 * Flow logic:
 * - /registration/location is now skipped in the normal registration flow
 * - Premium/corporate users are redirected back to /registration/location when they need to set their address
 *
 * Note: The default route redirects to /registration/location for backwards compatibility
 * and to handle cases where premium users need to provide their location.
 */
const registrationRoutes = [
  {
    path: '/registration',
    component: Registration,
    beforeEnter: combineGuards([requireSeeker, setSimpleHeaderGuard]),
    children: [
      {
        path: 'location',
        name: 'registration-location',
        component: Location,
      },
      {
        path: 'care_type',
        name: 'registration-care-type',
        component: CareTypeForm,
      },
      {
        path: 'add_employer',
        name: 'registration-add-employer',
        component: AddYourEmployer,
      },
      {
        path: 'request_upgrade',
        name: 'registration-request-upgrade',
        component: RequestUpgrade,
      },
      {
        path: 'upgrade_request_sent',
        name: 'registration-upgrade-request-sent',
        component: UpgradeRequestSent,
      },
      { path: '*', redirect: { name: 'registration-location' } },
      { path: '', redirect: { name: 'registration-location' } },
    ],
  },
];

export default registrationRoutes;
